import { IClassroomResource, IHydraResource, ITimestampable } from "@sol/sdk";
import { IBriefEducationalScenario } from "@sol/sdk/briefs/IBriefEducationalScenario";
import { IProfessionalSituationEducationalScenario } from "@sol/sdk/professionalSituations/IProfessionalSituationEducationalScenario";

import EntityTypes from "../EntityTypes";

export enum EducationalBriefStatus {
    DISPLAY = "displayed",
    HIDDEN = "hidden",
}
export interface EducationalBriefs extends IHydraResource {
    brief: IBriefEducationalScenario;
    rank: number;
    status: EducationalBriefStatus;
    uuid: string;
}

export interface EducationalClassroom extends IClassroomResource {
    trainers: string[];
}

export interface IEducationalScenarioItem extends IHydraResource, ITimestampable {
    "@type": EntityTypes.EDUCATIONAL_SCENARIO_ITEM;
    classroom: EducationalClassroom;
    educationalBriefs: EducationalBriefs[];
    professionalSituation: IProfessionalSituationEducationalScenario;
    endDate: string;
    startDate: string;
}
